<template>
  <div
    class="modal fade"
    id="teamModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog teampop modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h1>
            {{ constants.WELLBUX_TEAM_MEMBERS_TEXT }}
            15
          </h1>
          <button
            id="teamPopCloseBtn"
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <img src="@/assets/lems-v1/images/close-black-icon.svg" alt="" />
          </button>
        </div>
        <div class="modal-body">
          <div class="members-count">
            <ul>
              <li>
                <input
                  name="cssCheckbox"
                  id="pop_opt_1"
                  type="checkbox"
                  checked
                  class="css-checkbox"
                />
                <label for="pop_opt_1">
                  {{ constants.CURRENT_MEMBERS_BUTTON }}
                  <span>(7)</span>
                </label>
              </li>
              <li>
                <input
                  name="cssCheckbox"
                  id="pop_opt_2"
                  type="checkbox"
                  class="css-checkbox"
                />
                <label for="pop_opt_2">
                  {{ constants.PAST_MEMBERS_BUTTON }}
                  <span>(8)</span>
                </label>
              </li>
            </ul>
          </div>
          <div class="team-mem-sec-mid">
            <ul>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-active"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/nidhi.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Nidhi</strong>
                  <span>Business Analyst</span>
                </div>
              </li>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-active"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/shazaib.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Shazaib</strong>
                  <span>IOS Developer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-active"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/ashok.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Ashok Nagar</strong>
                  <span>UI/UX Designer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-active"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/nidhi.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Nidhi</strong>
                  <span>Business Analyst</span>
                </div>
              </li>
              <li>
                <div class="team-members-box past-team-members">
                  <div class="team-members-round">
                    <div class="user-cancel">
                      <img
                        src="@/assets/lems-v1/images/cancel-icon.svg"
                        alt=""
                      />
                    </div>
                    <img
                      src="@/assets/lems-v1/images/team-members/faizan.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Faizan</strong>
                  <span>Developer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box past-team-members">
                  <div class="team-members-round">
                    <div class="user-cancel">
                      <img
                        src="@/assets/lems-v1/images/cancel-icon.svg"
                        alt=""
                      />
                    </div>
                    <img
                      src="@/assets/lems-v1/images/team-members/ashwani.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Ashwani</strong>
                  <span>Developer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-away"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/sandeep.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Sandeep</strong>
                  <span>Developer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-active"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/ds-name-img.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Deepak</strong>
                  <span>Developer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-active"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/vimal.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Vimal Sharma</strong>
                  <span>UX Designer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-active"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/sandeep.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Sandeep</strong>
                  <span>Developer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box past-team-members">
                  <div class="team-members-round">
                    <div class="user-cancel">
                      <img
                        src="@/assets/lems-v1/images/cancel-icon.svg"
                        alt=""
                      />
                    </div>
                    <img
                      src="@/assets/lems-v1/images/team-members/faizan.jpg"
                      alt=""
                    />
                  </div>
                  <strong>faizan</strong>
                  <span>Developer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box past-team-members">
                  <div class="team-members-round">
                    <div class="user-cancel">
                      <img
                        src="@/assets/lems-v1/images/cancel-icon.svg"
                        alt=""
                      />
                    </div>
                    <img
                      src="@/assets/lems-v1/images/team-members/sandeep.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Sandeep</strong>
                  <span>Developer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-active"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/ashok.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Ashok Nagar</strong>
                  <span>UI/UX Designer</span>
                </div>
              </li>
              <li>
                <div class="team-members-box">
                  <div class="team-members-round">
                    <div class="user-status user-status-active"></div>
                    <img
                      src="@/assets/lems-v1/images/team-members/nidhi.jpg"
                      alt=""
                    />
                  </div>
                  <strong>Nidhi</strong>
                  <span>Business Analyst</span>
                </div>
              </li>
              <li>
                <div class="team-members-box past-team-members">
                  <div class="team-members-round">
                    <div class="user-cancel">
                      <img
                        src="@/assets/lems-v1/images/cancel-icon.svg"
                        alt=""
                      />
                    </div>
                    <img
                      src="@/assets/lems-v1/images/team-members/faizan.jpg"
                      alt=""
                    />
                  </div>
                  <strong>faizan</strong>
                  <span>Developer</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";

export default defineComponent({
  name: "ProjectTeamMembersPopup",
  data() {
    return {
      constants,
    };
  },
});
</script>
